import {inject} from "aurelia-framework";
import {Client} from "./api/client";
import {FlashService} from './flash/flash-service';
import {Provider} from "react-redux";
import store from './store/store';
import {MUI_TABLE_KEY} from './table/MuiTable/Table';

import {LicenseInfo} from '@mui/x-license';
import Dashboard from './dashboard/Dashboard';
import DashboardProvider from './dashboard/components/DashboardStore';

import {render, unmountComponentAtNode} from 'react-dom';
import React from 'react';
import 'gridstack';
import 'gridstack/dist/gridstack.css';
import 'react-grid-layout/css/styles.css';
import 'react-resizable/css/styles.css';
import './dashboard/assets/dashboard-styles.less';
import {UserClient} from "./api/user-client";

@inject(Client, FlashService, UserClient)
export class Welcome {

    object = {viewId: 'welcome'};

    isActive;

    constructor(client, flash, user)
    {
        this.client = client
        this.flash = flash
        this.user = user
    }

    reactRender() {
        if (this.container) {
            LicenseInfo.setLicenseKey(MUI_TABLE_KEY);
            render(
                <Provider store={store}>
                    <DashboardProvider value={{}}>
                        <Dashboard />
                    </DashboardProvider>
                </Provider>,
                this.container
            );
        }
    }

    async attached(){
        this.container = document.getElementById('sio-dashboard');
        this.isActive = await this.user.getUser()?.instance?.settings?.dashboardInstanceSettings?.isActive ?? false;
        if(this.isActive){
            this.reactRender();
        }
    }

    activate()
    {
        $(function () {
            var options = {
                cellHeight: 80,
                verticalMargin: 10,
                horizontalMargin: 10
            };
            $('.grid-stack').gridstack(options);
        });
    }

    detached() {
        unmountComponentAtNode(this.container);
    }
}
